module.exports = __webpack_public_path__ + "img/wash-info.5890862c.png";